import { Action, Dispatch } from 'redux'
import { confirmBreadAction } from 'reducks/bread/actions'
import { BreadType } from 'types/bread'

const confirmBread = (bread: BreadType) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(confirmBreadAction(bread))
  }
}

export default confirmBread
